
import { useState } from 'react';
import { VacationCard } from '../VacationCard';
import { VacationCardSkeleton } from '../VacationCardSkeleton';
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface LocalFavoritesGridProps {
  favoriteVacations: any[];
  loading: boolean;
  favoritesCount: number;
  onToggleFavorite: (vacationId: number) => void;
}

export const LocalFavoritesGrid = ({ 
  favoriteVacations, 
  loading, 
  favoritesCount,
  onToggleFavorite 
}: LocalFavoritesGridProps) => {
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3;
  const totalPages = Math.ceil(favoriteVacations.length / itemsPerPage);
  const displayedVacations = favoriteVacations.slice(
    currentPage * itemsPerPage, 
    (currentPage + 1) * itemsPerPage
  );

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Array.from({ length: Math.min(itemsPerPage, favoritesCount) }).map((_, index) => (
          <VacationCardSkeleton key={`fav-skeleton-${index}`} />
        ))}
      </div>
    );
  }

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {displayedVacations.map((vacation) => (
          <VacationCard
            key={`favorite-${vacation['product ID']}`}
            vacation={vacation}
            user={null}
            isFavorite={true}
            onFavoriteChange={() => onToggleFavorite(vacation['product ID'])}
          />
        ))}
      </div>

      {totalPages > 1 && (
        <div className="flex items-center justify-center gap-4 mt-4">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
            disabled={currentPage === 0}
            className="border-red-300 text-red-600 hover:bg-red-50"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <span className="text-sm text-red-700">
            {currentPage + 1} van {totalPages}
          </span>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setCurrentPage(prev => Math.min(totalPages - 1, prev + 1))}
            disabled={currentPage === totalPages - 1}
            className="border-red-300 text-red-600 hover:bg-red-50"
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      )}
    </>
  );
};
